var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 84,
    viewBox: "0 0 71 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7172 23.5778C36.7172 23.5778 40.6067 22.2051 41.5218 21.8619C42.3989 21.5568 46.2502 3.71104 42.2464 1.57565C38.2043 -0.559741 34.658 11.2612 36.7172 23.5778Z",
    fill: "url(#paint0_linear_340_3529)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2472 24.188C41.4464 24.6456 39.6542 24.188 39.6542 24.188C39.6542 24.188 45.641 8.17259 43.3149 3.63488C40.9889 -0.902823 38.8535 1.69015 38.0908 24.9125L36.0698 24.9888L29.0154 25.1795C29.0154 25.1795 20.8169 9.69788 21.3508 7.1049C21.8465 4.51192 33.6294 -0.559633 41.2939 0.0504788C41.3702 0.0504788 41.4465 0.0504788 41.5227 0.0504788C49.1873 0.774987 43.048 23.7304 42.2472 24.188Z",
    fill: "url(#paint1_linear_340_3529)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2469 24.1881C41.4461 24.6457 39.6539 24.1881 39.6539 24.1881C39.6539 24.1881 45.6406 8.17265 43.3146 3.63494C40.9885 -0.902765 38.8531 1.69021 38.0904 24.9126L36.0694 24.9889C36.0313 18.8877 36.3364 0.0505371 41.2935 0.0505371C41.3698 0.0505371 41.4461 0.0505371 41.5223 0.0505371C49.1869 0.775045 43.0476 23.7305 42.2469 24.1881Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9974 4.28323C39.5398 5.42719 37.6714 14.0069 39.311 17.21C40.9507 20.4512 44.1538 11.2233 43.8488 6.72368C43.5056 2.18597 41.6371 0.164975 39.9974 4.28323Z",
    fill: "#CA2790"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.769 25.1031C30.769 25.1031 23.7527 12.4814 22.685 9.50713C21.6173 6.4947 24.0959 4.51183 24.0959 4.51183L26.2313 3.40601C26.2313 3.40601 23.9434 5.88459 25.2399 10.346C26.2694 14.0067 31.6461 24.9887 31.6461 24.9887L30.769 25.1031Z",
    fill: "url(#paint2_linear_340_3529)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3063 24.9126C35.3063 24.9126 33.5903 11.0326 34.6199 6.11357C35.6495 1.19454 39.3864 0.0124512 39.3864 0.0124512C39.3864 0.0124512 36.7553 0.0887175 34.5055 0.622566C34.5055 0.622566 32.8277 1.69026 32.0269 5.88478C31.188 10.0793 34.1623 24.9889 34.1623 24.9889L35.3063 24.9126Z",
    fill: "url(#paint3_linear_340_3529)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7774 24.9889C29.7774 24.9889 24.5915 15.2271 26.5362 12.4435C28.4809 9.69798 35.5354 23.0823 35.6117 24.9126L29.7774 24.9889Z",
    fill: "#D42790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7775 24.9889C30.5783 26.0184 32.4468 22.3578 30.8452 17.8963C28.3666 10.88 26.5744 12.4435 26.1169 12.8248C25.6593 13.168 27.4896 22.0146 29.7775 24.9889Z",
    fill: "#D42790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8843 7.10494C20.2065 9.50726 34.2772 6.60922 37.2515 2.5291C40.1877 -1.51289 26.1169 0.965688 21.8843 7.10494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6247 13.0152C28.3664 9.08765 34.62 12.6721 35.3827 15.1125C36.1072 17.553 36.0691 21.2136 35.3827 21.7475C34.6582 22.2813 30.2348 15.0362 29.6247 13.0152Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6791 11.2613C36.4121 15.0745 39.7297 5.31272 40.2254 2.71974C40.7592 0.126765 39.3865 1.61392 39.3865 1.61392C39.3865 1.61392 37.2129 3.7493 36.6791 11.2613Z",
    fill: "#D42790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6039 7.29568C25.6591 7.75327 31.4934 10.3081 33.3237 12.4435C35.1541 14.617 37.6326 5.42722 37.6326 3.90194C37.6708 2.37666 35.1541 4.66457 32.0272 5.88479C28.8622 7.10502 28.4047 7.10502 27.6039 7.29568Z",
    fill: "#F36A90"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4639 65.2561C30.4639 65.2561 17.8803 85.0847 15.3254 83.9408C12.7325 82.7968 13.4188 74.7128 11.6266 73.2257C11.4995 73.124 11.3343 73.035 11.1309 72.9588C8.53792 71.9292 0.83521 73.035 0.0344335 71.4335C-0.842607 69.6794 15.3254 53.7402 15.3254 53.7402L30.4639 65.2561Z",
    fill: "url(#paint4_linear_340_3529)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0327 55.8374C18.0327 55.8374 3.69498 70.2894 3.123 71.0139C2.55102 71.7385 2.62728 72.3104 2.62728 72.3104H7.43194C7.43194 72.3104 7.31754 71.7766 7.58447 71.0139C7.81326 70.2513 21.1977 58.2016 21.1977 58.2016L18.0327 55.8374Z",
    fill: "url(#paint5_linear_340_3529)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.659 61.5955C25.659 61.5955 12.9229 77.1152 12.961 77.1914C12.961 77.3058 13.7237 81.4241 13.7237 81.4241C13.7237 81.4241 24.9345 67.6584 28.519 63.7309L25.659 61.5955Z",
    fill: "url(#paint6_linear_340_3529)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1306 72.9586C8.53766 71.9291 0.834955 73.0349 0.0341797 71.4334C0.339237 70.2894 8.30887 71.9291 9.79602 71.9291C10.4824 71.9291 10.9019 72.4248 11.1306 72.9586Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.464 65.2559C30.464 65.2559 17.8804 85.0845 15.3256 83.9405C16.9652 84.4363 26.0788 68.0776 30.464 65.2559Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3428 77.3058C13.5334 76.4287 17.1941 71.891 17.7661 71.5097C18.3381 71.1284 19.8634 72.1579 20.2066 72.6536C20.5116 73.1494 14.7918 79.7462 14.2961 80.1275C13.8004 80.4707 13.3428 77.3058 13.3428 77.3058Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16565 70.7471C6.25048 70.7852 4.6108 70.7852 4.30574 70.442C4.03882 70.0607 8.57655 65.5611 9.60612 64.8366C10.6357 64.074 12.8855 64.379 13.1905 64.8366C13.4956 65.256 7.16565 70.7471 7.16565 70.7471Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4159 65.2561C40.4159 65.2561 52.9995 85.0847 55.5544 83.9408C58.1474 82.7968 57.461 74.7128 59.2532 73.2257C59.3803 73.124 59.5455 73.035 59.7489 72.9588C62.3419 71.9292 70.0446 73.035 70.8454 71.4335C71.7224 69.6794 55.5544 53.7402 55.5544 53.7402L40.4159 65.2561Z",
    fill: "url(#paint7_linear_340_3529)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8472 55.8374C52.8472 55.8374 67.1849 70.2894 67.7569 71.0139C68.3289 71.7385 68.2526 72.3104 68.2526 72.3104H63.4861C63.4861 72.3104 63.5624 71.7766 63.2954 71.0139C63.0667 70.2513 49.6823 58.2016 49.6823 58.2016L52.8472 55.8374Z",
    fill: "url(#paint8_linear_340_3529)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2211 61.5955C45.2211 61.5955 57.9572 77.1152 57.9572 77.1914C57.9191 77.3058 57.1565 81.4241 57.1565 81.4241C57.1565 81.4241 45.9456 67.6584 42.3993 63.7309L45.2211 61.5955Z",
    fill: "url(#paint9_linear_340_3529)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7499 72.9586C62.3429 71.9291 70.0456 73.0349 70.8463 71.4334C70.5413 70.2894 62.5717 71.9291 61.0845 71.9291C60.3981 71.9291 60.0168 72.4248 59.7499 72.9586Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.416 65.2559C40.416 65.2559 52.9996 85.0845 55.5545 83.9405C53.9148 84.4363 44.8012 68.0776 40.416 65.2559Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5385 77.3058C57.3478 76.4287 53.6871 71.891 53.1152 71.5097C52.5432 71.1284 51.0179 72.1579 50.7128 72.6536C50.3696 73.1494 56.0895 79.7462 56.5852 80.1275C57.0809 80.4707 57.5385 77.3058 57.5385 77.3058Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7144 70.7471C64.6296 70.7852 66.2693 70.7852 66.5743 70.442C66.8413 70.0607 62.3035 65.5611 61.2739 64.8366C60.2444 64.074 57.9946 64.379 57.6895 64.8366C57.3845 65.256 63.7144 70.7471 63.7144 70.7471Z",
    fill: "white"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3768 43.216C58.3768 56.9054 48.0811 68.04 35.3449 68.04C22.6469 68.04 12.3131 56.9054 12.3131 43.216C12.3131 29.4885 22.6469 18.3921 35.3449 18.3921C48.0811 18.3921 58.3768 29.4885 58.3768 43.216Z",
    fill: "url(#paint10_linear_340_3529)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3768 41.1948C58.3768 53.8928 48.0811 64.2265 35.3449 64.2265C22.6469 64.2265 12.3131 53.8928 12.3131 41.1948C12.3131 28.4587 22.6469 18.1631 35.3449 18.1631C48.0811 18.1631 58.3768 28.4587 58.3768 41.1948Z",
    fill: "url(#paint11_linear_340_3529)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1786 41.1949C50.1786 49.3933 43.5436 56.0283 35.3451 56.0283C27.1849 56.0283 20.5117 49.3933 20.5117 41.1949C20.5117 32.9965 27.1849 26.3616 35.3451 26.3616C43.5436 26.3616 50.1786 32.9965 50.1786 41.1949Z",
    fill: "url(#paint12_linear_340_3529)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8058 42.4152C48.8058 49.8128 42.7809 55.8376 35.3451 55.8376C27.9475 55.8376 21.9226 49.8128 21.9226 42.4152C21.9226 34.9795 27.9475 28.9546 35.3451 28.9546C42.7809 28.9546 48.8058 34.9795 48.8058 42.4152Z",
    fill: "url(#paint13_linear_340_3529)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3113 37.4579C30.3113 37.4579 31.951 37.5723 33.2475 33.9116C33.2475 33.9116 35.6879 32.6151 38.2046 33.149L38.6622 52.2531H32.828L32.4086 41.1948L30.3113 40.966V37.4579Z",
    fill: "url(#paint14_linear_340_3529)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3113 36.0089C30.3113 36.0089 31.951 36.1233 33.2475 32.4626C33.2475 32.4626 35.6879 31.1661 38.2046 31.7L38.6622 50.8041H32.828L32.4086 39.7458L30.3113 39.517V36.0089Z",
    fill: "url(#paint15_linear_340_3529)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6941 45.2368C12.8466 46.8765 19.9392 45.1605 20.2443 45.008C20.5494 44.8174 18.4521 26.7047 35.3446 25.8657C52.2753 24.9887 50.5975 42.682 50.7882 43.9784C50.9788 45.2749 56.8512 43.9403 57.8426 42.415C58.8341 40.8898 55.6691 18.0487 35.9547 18.6207C16.2404 19.1927 11.5883 34.598 12.6941 45.2368Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1421 59.422C21.6549 56.7146 30.2347 57.2485 38.3187 55.8376C46.4027 54.4267 47.3942 49.584 50.1778 48.745C52.9996 47.9061 55.135 49.889 55.7832 50.8042C56.4696 51.7194 49.4533 62.2819 39.3864 63.5021C29.3576 64.7224 23.1421 59.422 23.1421 59.422Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7895 41.805C32.942 42.7583 36.6027 41.9957 37.5179 40.8136C38.3949 39.6315 37.8992 32.4627 37.8611 32.0814C37.8611 31.6619 33.8191 32.2339 33.4378 32.5771C33.0946 32.9203 32.2938 35.2844 31.5693 35.742C30.8066 36.1996 30.6541 36.4665 30.616 36.9241C30.5397 37.3817 30.616 39.0976 30.7685 39.212C30.921 39.3264 32.5607 39.2883 32.5607 39.2883C32.5607 39.2883 32.7514 41.3474 32.7895 41.805Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1346 55.1131C15.4397 53.5879 20.3587 59.8415 27.1463 63.2734C33.9719 66.6671 33.5144 67.4679 33.4381 67.9255C33.3618 68.4212 21.884 67.2391 15.1346 55.1131Z",
    fill: "#BD3EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.945 65.2562C44.3816 64.9893 48.0042 61.3668 50.1777 58.8119C52.3894 56.2571 54.4104 55.4563 55.9357 51.5668C57.4609 47.7155 55.4399 61.0617 45.945 65.2562Z",
    fill: "#BD3EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4764 64.2266C32.6375 64.5316 33.5909 67.2771 33.9722 67.6584C34.3916 68.0016 41.7511 66.8958 43.429 65.9425C45.1068 64.9892 47.1278 62.7776 46.899 61.6717C46.6702 60.5659 44.0009 63.9596 33.4764 64.2266Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1346 52.2151C15.1346 52.2151 21.4646 63.3115 35.2684 63.3496C49.0723 63.3878 55.631 52.2151 55.631 52.2151C55.631 52.2151 49.8349 64.1885 35.2684 64.5699C20.7019 64.9893 15.1346 52.2151 15.1346 52.2151Z",
    fill: "#FFC400"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2741 36.6954C20.7022 43.4829 24.2103 30.6705 33.5527 29.4503C44.7254 28.0013 46.6702 40.0891 49.4538 39.9366C52.2756 39.7459 47.5472 26.7429 36.6033 26.3997C24.2866 26.0565 21.2741 36.6954 21.2741 36.6954Z",
    fill: "#CA2790"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6299 51.4143C24.6299 51.4143 25.1256 52.1388 26.1933 52.9777C25.2019 52.1007 24.6299 51.4143 24.6299 51.4143Z",
    fill: "#FFD300"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9254 55.8375C30.6165 55.8375 27.7947 54.2741 26.1931 52.9776C28.0235 54.6173 31.341 56.8671 35.3448 56.8671C41.6367 56.8671 46.8989 50.499 46.8989 50.499C46.8989 50.499 42.1324 55.8375 34.9254 55.8375Z",
    fill: "#FFC400"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5065 63.6166C29.5493 63.7692 36.4894 59.0027 41.4084 55.0369C46.3275 51.0712 51.7804 54.0455 51.8566 55.0369C51.9329 55.9902 47.2426 63.2353 34.5065 63.6166Z",
    fill: "#E02774"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0355 19.3453C36.2604 19.1165 41.9421 24.7982 46.4035 26.3998C50.865 28.0013 49.8736 19.9936 40.0355 19.3453Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3372 53.6641C24.1341 52.6346 26.7271 55.4945 29.7395 56.0283C32.7901 56.5622 27.3372 53.6641 27.3372 53.6641Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3428 55.7231C13.3428 55.7231 13.9148 64.0359 17.5373 68.8787C21.198 73.7214 27.7949 69.3744 27.7949 69.3744L29.1676 67.1246C29.1676 67.1246 18.9482 64.2647 14.6774 54.1216L13.3428 55.7231Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5986 67.0865L44.0391 70.7853C44.0391 70.7853 49.1869 72.1199 54.106 67.0865C59.025 62.0912 56.699 54.8842 56.699 54.8842L56.0507 54.1216C56.0507 54.1216 51.3605 64.5698 41.5986 67.0865Z",
    fill: "#CA2790"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_3529",
    x1: 8.8193,
    y1: 23.595,
    x2: 8.8193,
    y2: 1.32856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_340_3529",
    x1: 20.1191,
    y1: 25.1657,
    x2: 20.1191,
    y2: -0.00290583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_340_3529",
    x1: -2.25763,
    y1: 9.09454,
    x2: 10.405,
    y2: -10.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_340_3529",
    x1: -6.12545,
    y1: 0.297679,
    x2: 7.50808,
    y2: -20.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_340_3529",
    x1: 0.243017,
    y1: 83.9926,
    x2: 0.243017,
    y2: 53.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_340_3529",
    x1: -3.4998,
    y1: 68.3176,
    x2: 9.53513,
    y2: 48.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_340_3529",
    x1: 0.473115,
    y1: 73.3172,
    x2: 14.1429,
    y2: 52.2675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_340_3529",
    x1: 70.6429,
    y1: 83.9926,
    x2: 70.6429,
    y2: 53.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_340_3529",
    x1: 74.3858,
    y1: 68.3176,
    x2: 61.3509,
    y2: 48.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_340_3529",
    x1: 70.4127,
    y1: 73.3172,
    x2: 56.7428,
    y2: 52.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_340_3529",
    x1: 14.447,
    y1: 84.0207,
    x2: -6.89298,
    y2: 25.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_340_3529",
    x1: 17.7164,
    y1: 79.0294,
    x2: -2.4778,
    y2: 23.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_340_3529",
    x1: 23.997,
    y1: 65.5609,
    x2: 10.9906,
    y2: 29.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_340_3529",
    x1: 25.0727,
    y1: 64.4677,
    x2: 13.2972,
    y2: 32.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_340_3529",
    x1: 12.38,
    y1: 52.2413,
    x2: 12.38,
    y2: 33.0246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_340_3529",
    x1: 12.38,
    y1: 50.7984,
    x2: 12.38,
    y2: 31.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiBonus);
export default __webpack_public_path__ + "static/media/affi-bonus.5ccf3c02ac31c2d37ff0a40ef965463f.svg";
export { ForwardRef as ReactComponent };